import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.css']
})
export class CookieBannerComponent implements OnInit {
  public mostrarBanner: boolean = false;
  public mostrarModalConfig: boolean = false;
  private readonly COOKIE_NAME = 'cookie_consent';

  public preferencias = {
    analiticas: false,
    publicidad: false
  };

  ngOnInit() {
    this.evaluarConsentimientoExistente();
  }

  private evaluarConsentimientoExistente() {
    const consentimiento = this.obtenerCookie(this.COOKIE_NAME);
    
    // Si la cookie existe (ya sea 'todas', 'rechazadas' o 'custom...'), el banner NO vuelve a aparecer
    if (consentimiento) {
      this.mostrarBanner = false;
      this.procesarConsentimiento(consentimiento);
    } else {
      this.mostrarBanner = true;
    }
  }

  // Se ejecuta al pulsar los botones directos del banner principal
  public guardarConsentimiento(tipo: 'rechazadas' | 'todas') {
    if (tipo === 'todas') {
      this.preferencias.analiticas = true;
      this.preferencias.publicidad = true;
    } else if (tipo === 'rechazadas') {
      // Se fuerza el apagado total. No se da consentimiento.
      this.preferencias.analiticas = false;
      this.preferencias.publicidad = false;
    }

    // Almacena 'rechazadas' o 'todas' por 12 meses
    this.fijarCookie(this.COOKIE_NAME, tipo, 365);
    this.mostrarBanner = false;
    this.procesarConsentimiento(tipo);
  }

  // Se ejecuta desde el panel del botón 'Configurar'
  public guardarConfiguracionPersonalizada() {
    let valorCookie = 'rechazadas'; // Por defecto, si todo está desmarcado, equivale a rechazar

    if (this.preferencias.analiticas && this.preferencias.publicidad) {
      valorCookie = 'todas';
    } else if (this.preferencias.analiticas || this.preferencias.publicidad) {
      valorCookie = `custom_${this.preferencias.analiticas ? '1' : '0'}_${this.preferencias.publicidad ? '1' : '0'}`;
    }

    this.fijarCookie(this.COOKIE_NAME, valorCookie, 365);
    this.mostrarModalConfig = false;
    this.mostrarBanner = false;
    
    this.procesarConsentimiento(valorCookie);
  }

  private procesarConsentimiento(consentimiento: string) {
    if (consentimiento === 'todas') {
      this.activarAnaliticas();
      this.activarPublicidad();
    } else if (consentimiento.startsWith('custom_')) {
      const partes = consentimiento.split('_');
      this.preferencias.analiticas = partes[1] === '1';
      this.preferencias.publicidad = partes[2] === '1';

      if (this.preferencias.analiticas) this.activarAnaliticas();
      if (this.preferencias.publicidad) this.activarPublicidad();
    } else if (consentimiento === 'rechazadas') {
      // Bloqueo absoluto. No se ejecuta ninguna función.
      console.log('El usuario denegó el consentimiento. No se activa ninguna cookie no esencial.');
    }
  }

  private activarAnaliticas() {
    console.log('Ejecutando scripts de analítica (Consentimiento otorgado).');
  }

  private activarPublicidad() {
    console.log('Ejecutando scripts publicitarios y Meta Pixel (Consentimiento otorgado).');
  }

  // Métodos utilitarios nativos para cookies
  private obtenerCookie(nombre: string): string | null {
    const nameEQ = nombre + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  private fijarCookie(nombre: string, valor: string, dias: number) {
    let expiracion = "";
    if (dias) {
      const date = new Date();
      date.setTime(date.getTime() + (dias * 24 * 60 * 60 * 1000));
      expiracion = "; expires=" + date.toUTCString();
    }
    document.cookie = nombre + "=" + (valor || "") + expiracion + "; path=/; SameSite=Lax; Secure";
  }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/tia-box-dev/src/app/componentes/cookie-banner/cookie-banner.component.ts